import { Button } from "primereact/button";
import { editUser } from "../../../../../api-requests/users";
import EditIcon from "../../../../../components/icons/EditIcon";
import type { User } from "../../../../../helpers/format-users";
import { syncOpenModalDialog } from "../../../../shared/global-tools/dialog-system";
import makeEditUserDialog, { type EditUserDialogParameter } from "./EditUserDialog";

export default function EditUser({ user, refreshUsers }: { user: User; refreshUsers: () => void }) {
  return (
    <Button
      className="IconOnlyBtn p-outlined-primary"
      icon={<EditIcon />}
      rounded
      text
      onClick={() =>
        syncOpenModalDialog<EditUserDialogParameter>(makeEditUserDialog, {
          edit: (body) => editUser(user.id, body),
          refreshUsers,
          userToEdit: user,
        })
      }
    />
  );
}
